import Milestones from './Milestones'

export default Milestones
